import React, {useEffect, useState} from 'react';
import JobListTable from "@pages/job/list/JobListTable";
import {DEFAULT_PAGE_SIZE} from "@app/constants/Common";
import {requestGetJobList} from "@app/services/JobService";
import AdvanceSearchJobModal from "@pages/job/list/advancesearch/AdvanceSearchJobModal";

const JobList = (props) => {
    const [jobs, setJobs] = useState([]);
    const [allJobIds, setAllJobIds] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showAdvanceSearchModal, setShowAdvanceSearchModal] = useState(false);
    const [advanceSearchInput, setAdvanceSearchInput] = useState({});

    const searchJobList = (condition) => {
        setShowAdvanceSearchModal(false)
        setIsLoading(true)

        // let params = {page: page, size: DEFAULT_PAGE_SIZE}
        let params = {search_conditions: condition}
        requestGetJobList(params). then((res) => {
            const items = res.content.jobs.map((item, index) => {
                item.no = (res.content.page - 1) * DEFAULT_PAGE_SIZE + index + 1
                return item
            });
            setJobs(items);
            setAllJobIds(res.content.all_job_ids);
            setTotalCount(res.content.totalCount)
            // setCurrentPage(res.content.page)
            // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            setJobs([]);
            setAllJobIds([]);
            setTotalCount(0)
            // setNumberPages(0);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        searchJobList()
    }, []);

    return (
        <div className='container-fluid'>
            <div className='card card-primary'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>{'Danh sách Job'}</h3>
                    <div className='card-tools'>
                        <a href='#'
                                onClick={() => {
                                    setShowAdvanceSearchModal(true)
                                    setAdvanceSearchInput({...advanceSearchInput})
                                }}>
                            <i className='fas fa-filter mr-2'/>
                        </a>
                    </div>
                </div>
                <div className='card-body'>
                    <div style={{position: 'relative'}}>
                        <AdvanceSearchJobModal isShow={showAdvanceSearchModal}
                                               advanceSearchInput={advanceSearchInput}
                                                   onSearch={(searchInput) => {
                                                       setAdvanceSearchInput(searchInput)
                                                       searchJobList(searchInput)
                                                   }}
                                                   onClose={() => setShowAdvanceSearchModal(false)} />
                        <JobListTable jobs={jobs}
                                      allJobIds={allJobIds}
                                      totalCount={totalCount}
                                      onSearch={(condition) => searchJobList(condition)}/>
                        {isLoading &&
                        <div className={'col-sm-12 text-center'}
                             style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                            <div className='spinner-grow text-primary' role='status'>
                                <span className='sr-only'>Loading...</span>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobList;
